import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import * as webRTCHandler from "../../utils/webRTCHandler";

const VideoSection = () => {
  const screenSharingUser = useSelector((state) => state.screenSharingUser);
  const participants = useSelector((state) => state.participants);
  const identity = useSelector((state) => state.identity);
  const [activeScreenShareId, setActiveScreenShareId] = useState(null);

  useEffect(() => {
    // Clear previous screen share styling
    if (activeScreenShareId) {
      if (activeScreenShareId === "local-screen-share") {
        webRTCHandler.setScreenShareVideoContainer("local-video-container", false);
      } else {
        webRTCHandler.setScreenShareVideoContainer(activeScreenShareId, false);
      }
    }

    // Check if current user or another user is sharing screen
    if (screenSharingUser) {
      // Find the participant who is sharing screen
      if (screenSharingUser === identity) {
        // Current user is sharing - show local screen share
        setActiveScreenShareId("local-screen-share");
        setTimeout(() => {
          webRTCHandler.setScreenShareVideoContainer("local-video-container", true);
        }, 100);
      } else {
        // Another user is sharing - find their socket id
        const participant = participants.find(p => p.identity === screenSharingUser);
        if (participant) {
          setActiveScreenShareId(participant.socketId);
          setTimeout(() => {
            webRTCHandler.setScreenShareVideoContainer(participant.socketId, true);
          }, 100);
        } else {
          setActiveScreenShareId(null);
        }
      }
    } else {
      setActiveScreenShareId(null);
    }
  }, [screenSharingUser, participants, identity]);

  const isScreenSharingActive = activeScreenShareId !== null;

  return (
    <div className={`video_section_container ${isScreenSharingActive ? 'screen-sharing-active' : ''}`}>
      {/* Videos Portal - This is where all video streams are rendered */}
      <div
        id="videos_portal"
        className={`videos_portal_styles ${isScreenSharingActive ? 'screen-share-mode' : ''}`}
      >
        {/* Video elements will be added here dynamically via webRTCHandler */}
      </div>
    </div>
  );
};

export default VideoSection;
